export const indonesiaOnlineTerms = (
  <>
    <h5>
      Sebelum melanjutkan, silakan baca dan setujui syarat dan ketentuan berikut untuk Peserta Online:
    </h5>
    <ul>
      <li>
        Dengan ini kami informasikan bahwa data yang telah diisikan oleh peserta tidak dapat diubah setelah batas waktu pembayaran berakhir. Sehubungan dengan hal tersebut, kami mohon agar setelah melakukan pengisian data, peserta memeriksa kembali LoA serta data registrasi untuk memastikan seluruh informasi yang tercantum telah benar dan sesuai.
      </li>
      <li>
        Peserta yang tidak mengumpulkan berkas persyaratan (Full Paper) sampai batas waktu yang telah ditentukan, maka tidak akan mendapatkan nilai berkas dan hanya akan mendapatkan nilai pada saat sesi live judging saja.
      </li>
      <li>
        Peserta wajib menggunakan judul dan full paper yang sesuai dengan kategori yang diikuti. (untuk peserta yang mengikuti event tingkat internasional, wajib menggunakan bahasa Inggris untuk seluruh requirement).
      </li>
      <li>
        Keputusan panitia terkait hal ini bersifat final dan tidak dapat diganggu gugat.
      </li>
    </ul>
    <p className="text-align">
      Selain itu, kami informasikan bahwa setiap acara akan didaftarkan untuk proses kurasi oleh SIM T Puspresnas.
    </p>
    <p className="text-align">
      Namun, hasil kurasi sepenuhnya berada di bawah kewenangan Puspresnas dan tidak dapat digugat oleh pihak manapun. Oleh karena itu, kami tidak menerima keberatan atau keluhan terkait hasil yang ditentukan oleh Puspresnas.
    </p>
  </>
);

export const indonesiaOfflineTerms = (
  <>
    <h5>
      Sebelum melanjutkan, silakan baca dan setujui syarat dan ketentuan berikut untuk Peserta Offline:
    </h5>
    <ul>
      <li>
        Dengan ini kami informasikan bahwa data yang telah diisikan oleh peserta tidak dapat diubah setelah batas waktu pembayaran berakhir. Sehubungan dengan hal tersebut, kami mohon agar setelah melakukan pengisian data, peserta memeriksa kembali LoA serta data registrasi untuk memastikan seluruh informasi yang tercantum telah benar dan sesuai.
      </li>
      <li>
        Peserta yang tidak mengumpulkan berkas persyaratan (Full Paper) sampai batas waktu yang telah ditentukan, maka tidak akan mendapatkan nilai berkas dan hanya akan mendapatkan nilai pada saat sesi live judging saja.
      </li>
      <li>
        Peserta wajib menggunakan judul dan full paper yang sesuai dengan kategori yang diikuti. (untuk peserta yang mengikuti event tingkat internasional, wajib menggunakan bahasa Inggris untuk seluruh requirement).
      </li>
      <li>
        Peserta diwajibkan untuk membuat poster berukuran A0, membawa produk dan poster tersebut pada saat sesi penjurian.
      </li>
      <li>
        Pemberian penghargaan kepada peserta akan dilakukan sesuai dengan urutan yang telah ditetapkan dalam susunan acara (peserta tidak diperkenankan untuk meminta award sebelum gilirannya).
      </li>
      <li>
        Peserta diwajibkan untuk mengikuti seluruh rangkaian kegiatan sesuai dengan jadwal yang telah disusun oleh panitia penyelenggara.
      </li>
      <li>
        Bagi peserta offline yang berhak atas hadiah Best booth, Best Poster, Best Presentation, Best Project, uang tunai, semi grand award, dan grand award namun tidak dapat hadir pada acara penyerahan hadiah, maka hadiah yang bersangkutan dinyatakan hangus.
      </li>
      <li>
        Keputusan panitia terkait hal ini bersifat final dan tidak dapat diganggu gugat.
      </li>
    </ul>
    <p className="text-align">
      Selain itu, kami informasikan bahwa setiap acara akan didaftarkan untuk proses kurasi oleh SIM T Puspresnas.
    </p>
    <p className="text-align">
      Namun, hasil kurasi sepenuhnya berada di bawah kewenangan Puspresnas dan tidak dapat digugat oleh pihak manapun. Oleh karena itu, kami tidak menerima keberatan atau keluhan terkait hasil yang ditentukan oleh Puspresnas.
    </p>
  </>
);